import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, UserCheck, Network as NetworkIcon } from 'lucide-react';
import { User, Role, Network } from '../../types';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface UserStatisticsProps {
  users: User[];
  networks: Network[];
}

export const UserStatistics: React.FC<UserStatisticsProps> = ({ users, networks }) => {
  const { t } = useTranslation();

  // Calcul des statistiques
  const totalUsers = users.length;
  const adminCount = users.filter(user => user.role === 'ADMIN').length;
  const clientCount = users.filter(user => user.role === Role.CLIENT).length;
  const networkCount = networks.length;

  const stats = [
    {
      title: t('userStatistics.totalUsers'),
      value: totalUsers,
      icon: Users,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50 dark:bg-blue-900/20',
    },
    {
      title: t('userStatistics.admins'),
      value: adminCount,
      icon: UserCheck,
      color: 'text-green-600',
      bgColor: 'bg-green-50 dark:bg-green-900/20',
    },
    {
      title: t('userStatistics.clients'),
      value: clientCount,
      icon: Users,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50 dark:bg-purple-900/20',
    },
    {
      title: t('userStatistics.networks'),
      value: networkCount,
      icon: NetworkIcon,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50 dark:bg-orange-900/20',
    },
  ];

  return (
    <Card className="border-none shadow-sm dark:shadow-lg">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <Users className="h-5 w-5 text-primary" />
          {t('userStatistics.title')}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-1 gap-3">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="flex items-center justify-between p-3 rounded-lg border border-border/40 bg-muted/20"
              >
                <div className="flex items-center gap-3">
                  <div className={`p-2 rounded-full ${stat.bgColor}`}>
                    <Icon className={`h-4 w-4 ${stat.color}`} />
                  </div>
                  <span className="text-sm font-medium text-muted-foreground">
                    {stat.title}
                  </span>
                </div>
                <span className="text-xl font-bold text-foreground">
                  {stat.value}
                </span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};